import { useNavigation } from '@actr/hooks';
import { AuthApplication, AuthRequirement, resolveAuthPolicy } from '@actr/widgets/src/navigation/auth-policy';

import config from '../../configs';
import ProjectUtils from '../../utils/project';

/**
 * Требует ли текущая страница канала ВТБ авторизации.
 *
 * Требование берётся из реестра политики авторизации, а не из локального
 * перечня маршрутов: реестр является единственным объявлением правила.
 */
export function useNeededAuthVtbPage(): boolean {
  const { isRoute } = useNavigation();

  if (!ProjectUtils.isVtb()) {
    return false;
  }

  return resolveAuthPolicy(AuthApplication.PUBLIC_SITE, config.projectType, isRoute).requirement === AuthRequirement.REQUIRED;
}
